<template>
    <div
        :data-diamond="product.id"
        class="bsdc:w-full bsdc:bg-2-1 bsdc:border bsdc:border-2-1 bsdc:rounded-lg bsdc:transition-colors"
        :class="{
            'active bsdc:bg-transparent': isOpen,
            'selected': checked,
        }"
    >
        <div
            class="bsdc:p-3 bsdc:sm:p-5 bsdc:sm:items-center bsdc:flex bsdc:gap-5 bsdc:cursor-pointer"
            @click.prevent="isOpen = !isOpen"
        >
            <div
                class="bsdc:w-[30%] bsdc:sm:w-[105px] bsdc:sm:shrink-0 bsdc:bg-neutral-200 bsdc:aspect-square bsdc:self-start bsdc:rounded-md">
                <img
                    v-if="product.image_url"
                    width="105"
                    height="105"
                    class="bsdc:rounded-md bsdc:size-full bsdc:object-cover"
                    :src="product.image_url"
                    alt=""
                />
            </div>

            <div class="bsdc:max-sm:w-[70%] bsdc:w-full bsdc:flex bsdc:flex-col bsdc:gap-5">
                <div class="bsdc:gap-1.5 bsdc:sm:gap-5 bsdc:flex bsdc:max-sm:flex-col">
                    <div>
                        <p
                            v-if="product.setting_weight?.label"
                            class="bsdc:max-sm:text-sm"
                        >
                            <span
                                class="bsdc:max-sm:text-sm"
                                v-html="product.setting_weight?.label"
                            ></span>
                            Total with setting
                        </p>

                        <div class="bsdc:flex bsdc:gap-1 bsdc:mt-1 bsdc:sm:mt-1.5">
                            <p
                                v-if="product.brand == 'nivoda'"
                                class="bsdc:tag"
                            >
                                with our Diamond Dealers
                            </p>

                            <p
                                v-else-if="product.brand == 'app'"
                                class="bsdc:tag"
                            >
                                View in Showroom
                            </p>
                        </div>
                    </div>

                    <p
                        v-if="product.setting_price"
                        class="bsdc:sm:ml-auto bsdc:max-sm:text-sm bsdc:max-sm:mt-1"
                        v-html="formatMoney(product.setting_price_decimal)"
                    ></p>
                </div>

                <div class="bsdc:sm:items-center bsdc:flex bsdc:max-sm:flex-col bsdc:gap-5 bsdc:lg:gap-32">
                    <DataList
                        :data="data"
                        :version="1"
                    />

                    <p
                        class="bsdc:self-end bsdc:sm:ml-auto bsdc:sm:shrink-0 bsdc:pointer-events-none button button-small"
                        :class="{
                            'button-ghost': isOpen,
                        }"
                    >
                        Details
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="8"
                            height="4.5"
                            viewBox="0 0 8 4.5"
                            fill="currentColor"
                            class="bsdc:w-[9px] bsdc:transition-transform"
                            :class="{
                                'bsdc:rotate-180': isOpen,
                            }"
                        >
                            <path
                                d="M0,.5C0,.37207.04883.24414.14648.14648.3418-.04883.6582-.04883.85352.14648l3.14648,3.14648L7.14648.14648c.19531-.19531.51172-.19531.70703,0s.19531.51172,0,.70703l-3.5,3.5c-.19531.19531-.51172.19531-.70703,0L.14648.85352c-.09766-.09766-.14648-.22559-.14648-.35352Z"
                            />
                        </svg>
                    </p>
                </div>
            </div>
        </div>

        <div
            v-if="isOpen"
            class="bsdc:p-3 bsdc:sm:p-5 bsdc:max-lg:flex-col bsdc:flex bsdc:gap-6 bsdc:border-t bsdc:border-solid bsdc:border-2-1"
        >
            <div
                class="bsdc:max-lg:w-full bsdc:lg:max-w-[50%] bsdc:lg:w-[420px] bsdc:sm:shrink-0 bsdc:text-center bsdc:aspect-square bsdc:bg-neutral-200 bsdc:rounded-md bsdc:[&_img]:w-full">
                <Carousel
                    v-if="product.image_url && videoEmbed"
                    :image-urls="[product.image_url]"
                    :video-embed="videoEmbed"
                />
                <img
                    v-else-if="product.image_url"
                    :src="product.image_url"
                    class="bsdc:rounded-md"
                    alt=""
                />
            </div>

            <div class="bsdc:ml-auto bsdc:w-full">
                <DataList
                    :data="dataSecondary"
                    :version="2"
                />

                <div class="bsdc:mt-5 bsdc:max-sm:flex-col bsdc:flex bsdc:gap-2 bsdc:sm:gap-4">
                    <label
                        class="bsdc:w-full button bsdc:grow bsdc:basis-0"
                        :class="{
                            'button-ghost bsdc:pointer-events-none': checked,
                        }"
                        :for="'diamond-' + product.id"
                    >
                        <template v-if="checked">
                            Selected
                        </template>
                        <template v-else>
                            Choose Diamond
                        </template>

                        <input
                            :id="'diamond-' + product.id"
                            class="bsdc:hidden"
                            type="radio"
                            name="diamond_id"
                            @change="emit('selected', product); scrollToElementById('config-section-2');"
                            :value="product.id"
                            :checked="checked"
                        />
                    </label>

                    <a
                        class="button button-ghost bsdc:grow bsdc:basis-0"
                        :href="viewDiamondUrl()"
                        target="_blank"
                    >
                        View Diamond
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="bsdc:w-3.5"
                        >
                            <path d="M15 3h6v6" />
                            <path d="M10 14 21 3" />
                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, computed, watch, onMounted, onUnmounted } from 'vue';

    import { scrollToElementById, formatMoney } from "@js/helpers";

    import DataList from "@js/Components/DataList.vue";
    import Carousel from "@js/Components/Carousel.vue";

    const props = defineProps({
        product: Object,
        checked: Boolean,
    });

    const emit = defineEmits(["selected"]);

    const viewDiamondUrl = () => {
        const ringMetalSelect = document.querySelector('.variations_form select[name="attribute_pa_ring-metal"]') || document.querySelector('.variations_form select[name="attribute_pa_metal"]');
        const ringSizeSelect = document.querySelector('.variations_form select[name="attribute_pa_ring-size"]') || document.querySelector('.variations_form select[name="attribute_pa_size"]');

        const ringMetal = ringMetalSelect ? ringMetalSelect.options[ringMetalSelect.selectedIndex].text : null;
        const ringSize = ringSizeSelect ? ringSizeSelect.options[ringSizeSelect.selectedIndex].text : null;

        const url = new URL(BSDC.productUrl);
        url.searchParams.set('variation', document.querySelector('.single_variation_wrap input[name="variation_id"]').value);
        url.searchParams.set('diamond', props.product?.id);
        url.searchParams.set('brand', props.product?.brand);
        url.searchParams.set('metal', ringMetal);
        url.searchParams.set('size', ringSize);

        return url.href;
    };

    const isOpen = ref(false);

    // Use matchMedia to toggle between 309 and 420 size variants only when crossing breakpoint
    const mq = typeof window !== 'undefined' ? window.matchMedia('(max-width: 375px)') : null;
    const isSmallScreen = ref(mq ? mq.matches : false);

    const mqListener = (e) => {
        isSmallScreen.value = e.matches;
    };

    onMounted(() => {
        if (mq) {
            if (typeof mq.addEventListener === 'function') {
                mq.addEventListener('change', mqListener);
            } else {
                mq.onchange = mqListener;
            }
        }
    });

    onUnmounted(() => {
        if (mq) {
            if (typeof mq.removeEventListener === 'function') {
                mq.removeEventListener('change', mqListener);
            } else if ('onchange' in mq) {
                mq.onchange = null;
            }
        }
    });

    const videoEmbed = computed(() => {
        const base = props.product?.video_embed_card || null;

        if (!base) {
            return null;
        }

        return isSmallScreen.value
            ? base.replace(/video\/420\/420/g, 'video/309/309')
            : base.replace(/video\/309\/309/g, 'video/420/420');
    });

    const data = computed(() => {
        const p = props.product || {};

        if (p.stone?.value !== 'diamond') {
            return [
                { label: 'Gemstone Species', value: p.stone?.label || '-' },
                { label: 'Shape', value: p.shape?.label || '-' },
                { label: 'Weight', value: p.weight?.label || '' },
                { label: 'Clarity', value: p.clarity ?? '-' },
                { label: 'Cut', value: p.cut ?? '-', tooltip: "The cut of a gemstone refers to its shape and facet arrangement, affecting brilliance and appearance. Some cuts enhance sparkle, while others highlight colour or clarity." },
                { label: 'Cert', value: p.certificate_body ?? '-' },
            ];
        }

        return [
            { label: 'Shape', value: p.shape?.label || '-' },
            { label: 'Weight', value: p.weight?.label || '-' },
            { label: 'Colour', value: p.color_shade ?? p.color ?? '-' },
            { label: 'Clarity', value: p.clarity ?? '-' },
            { label: 'Cut', value: p.cut ?? '-' },
            { label: 'Cert', value: p.certificate_body ?? '-' },
        ];
    });

    const dataSecondary = computed(() => {
        const p = props.product || {};

        if (p.stone?.value !== 'diamond') {
            return [
                { label: 'Measurements', value: p.measurements ?? '-' },
                { label: 'Colour Shade', value: p.color_shade ? p.color_shade : '-' },
                { label: 'Treatment', value: p.treatment ? p.treatment : '-', tooltip: "Treatments improve a gemstone's colour, clarity, or durability. Common methods include heating, oiling, and coating, with some stones left untreated for a natural look." },
                { label: 'Mine of Origin', value: p.mine_of_origin ? p.mine_of_origin : '-', tooltip: "A gemstone's origin indicates where it was mined. Different regions produce gems with unique characteristics, influencing their rarity, value, and appeal." },
            ];
        }

        return [
            { label: 'Measurements', value: p.measurements ?? '-' },
            { label: 'Polish', value: p.polish ?? '-' },
            { label: 'Symmetry', value: p.symmetry ?? '-' },
            { label: 'Fluorescence', value: p.fluorescence ?? '-' },
            { label: 'Table', value: p.table ? `${p.table}%` : '-' },
            { label: 'Depth', value: p.depth ? `${p.depth}%` : '-' },
            { label: 'Ratio', value: p.ratio ?? '-' },
        ];
    });

    watch(isOpen, (val) => {
        if (val) window.dispatchEvent(new Event('resize'));
    });
</script>
